import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
export class BudgetResponsibleResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.email = "";
        this.firstName = "";
        this.lastName = "";
        this.phone = "";
        this.fullName = "";
    }
    pk() {
        return "GetBudgetResponsible";
    }
}
BudgetResponsibleResource.automaticValidation = "silent";
BudgetResponsibleResource.urlRoot = legacyApiResourceUrl("VulcanData/GetBudgetResponsible");
//# sourceMappingURL=BudgetResponsibleResource.js.map